export default function AboutPlatform() {
  return (
    <section id="about" className="bg-white py-32">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-teal-50 border border-teal-100 rounded-full mb-6">
              <i className="ri-shield-check-line text-teal-600 text-lg"></i>
              <span className="text-teal-700 text-sm font-semibold">Trusted by Teams Nationwide</span>
            </div>

            <h2 className="text-5xl lg:text-6xl font-bold text-gray-900 mb-6 leading-tight">
              Built for Athletic Directors Who Value Their Time
            </h2>

            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              TeamPro was created by former athletic directors who understand the challenges of managing equipment across multiple sports programs. We built the platform we wished we had.
            </p>

            <div className="space-y-6 mb-10">
              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-teal-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-team-line text-teal-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Multi-Sport Support</h3>
                  <p className="text-gray-600">
                    Manage equipment for football, basketball, baseball, soccer, hockey, and more - all from one platform.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-pink-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-secure-payment-line text-pink-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Secure & Reliable</h3>
                  <p className="text-gray-600">
                    Enterprise-grade security with encrypted payments, secure data storage, and reliable order processing.
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <div className="w-12 h-12 bg-amber-100 rounded-xl flex items-center justify-center flex-shrink-0">
                  <i className="ri-customer-service-line text-amber-600 text-2xl"></i>
                </div>
                <div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">Dedicated Support</h3>
                  <p className="text-gray-600">
                    Our team of former athletic directors provides expert support to help you maximize the platform's value.
                  </p>
                </div>
              </div>
            </div>

            <button 
              onClick={() => {
                const element = document.getElementById('testimonials');
                element?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="px-8 py-4 bg-gray-900 text-white text-lg font-semibold rounded-full hover:bg-gray-800 transition-all shadow-lg whitespace-nowrap cursor-pointer"
            >
              See Success Stories
            </button>
          </div>

          <div className="relative">
            <div className="absolute inset-0 bg-gradient-to-br from-teal-200 to-pink-200 rounded-3xl blur-3xl opacity-30"></div>
            <div className="relative bg-gradient-to-br from-gray-50 to-white rounded-3xl p-10 shadow-xl border border-gray-100">
              <div className="space-y-8">
                <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100">
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-3">
                      <div className="w-12 h-12 bg-gradient-to-br from-teal-500 to-teal-600 rounded-xl flex items-center justify-center">
                        <i className="ri-time-line text-white text-xl"></i>
                      </div>
                      <div>
                        <div className="text-sm text-gray-500">Time Saved</div>
                        <div className="text-2xl font-bold text-gray-900">20 hrs/week</div>
                      </div>
                    </div>
                    <div className="text-teal-600 text-sm font-semibold">↑ 85%</div>
                  </div>
                  <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
                    <div className="h-full bg-gradient-to-r from-teal-500 to-teal-600 rounded-full" style={{ width: '85%' }}></div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100">
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-3">
                      <div className="w-12 h-12 bg-gradient-to-br from-pink-500 to-pink-600 rounded-xl flex items-center justify-center">
                        <i className="ri-shopping-cart-line text-white text-xl"></i>
                      </div>
                      <div>
                        <div className="text-sm text-gray-500">Orders Processed</div>
                        <div className="text-2xl font-bold text-gray-900">1,247</div>
                      </div>
                    </div>
                    <div className="text-pink-600 text-sm font-semibold">This Month</div>
                  </div>
                  <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
                    <div className="h-full bg-gradient-to-r from-pink-500 to-pink-600 rounded-full" style={{ width: '92%' }}></div>
                  </div>
                </div>

                <div className="bg-white rounded-2xl p-6 shadow-lg border border-gray-100">
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-3">
                      <div className="w-12 h-12 bg-gradient-to-br from-amber-500 to-amber-600 rounded-xl flex items-center justify-center">
                        <i className="ri-star-line text-white text-xl"></i>
                      </div>
                      <div>
                        <div className="text-sm text-gray-500">Customer Satisfaction</div>
                        <div className="text-2xl font-bold text-gray-900">4.9/5.0</div>
                      </div>
                    </div>
                    <div className="text-amber-600 text-sm font-semibold">★★★★★</div>
                  </div>
                  <div className="h-2 bg-gray-100 rounded-full overflow-hidden">
                    <div className="h-full bg-gradient-to-r from-amber-500 to-amber-600 rounded-full" style={{ width: '98%' }}></div>
                  </div>
                </div>
              </div>

              <div className="mt-8 pt-8 border-t border-gray-200">
                <div className="flex items-center justify-between text-sm">
                  <span className="text-gray-600">Trusted by 50+ teams</span>
                  <span className="text-gray-900 font-semibold">From high school to professional</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
